import { Component } from 'react'
import Accordions from './Accordions';
import Service from '../Networking/NetworkingUtils'
import { getCookie } from '../Utils/CookieHelper';
import errorMessage from '../Networking/ErrorMessage';
import { Box, CircularProgress } from '@mui/material';
import SnackbarUtils from '../SnackbarUtils/SnackbarUtlis';
// import TimeSheetDialog from '../../TimeSheet/TimeSheetDialog';

const token = getCookie("bb_metaverse_token");


class UserPermission extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            data: [],
            comData: {},
            resData: {},
        }
        this.rewriteData = this.rewriteData.bind(this)
    }

    componentDidMount() {
        this.fetchOps();
    }

    fetchOps() {
        Service.get(`/api/access/get_access_permissions/?uid=` + this.props.value.id, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    data: res.data,
                });
                this.compileData(res.data);
            })
            .catch(error => {
                this.setState({ isLoading: false })
                // this.props.enqueueSnackbar('Something went wrong!', {
                //     variant: 'error'
                // });
                SnackbarUtils.error('Something went wrong!')
            });
    }

    compileData(response) {
        var loca = {
            l0a: {
                l0a_a: false,
                l0a_b: false,
            },
            l0b: {
                l0b_a: false,
                l0b_b: false,
            },
            l0c:{
                l0c_a: false
            }
        };
        var data = {
            l0a: {
                left: [],
                right: [],
            },
            l0b: {
                left: [],
                right: [],
            },
            l0c: {
                left: [],
                right: [],
            },
        };

        if (response.length !== 0) {
            loca = response[0].access;
        }
        if (!loca.l0a) {
            loca.l0a = {}
        }
        if (!loca.l0b) {
            loca.l0b = {}
        }
        if (!loca.l0c) {
            loca.l0c = {}
        }
      

        if (loca.l0a && loca.l0a.l0a_a) {
            data.l0a.right.push({
                id: 'l0a_a',
                name: 'View Project Tab'
            })
        } else if (loca.l0a) {
            data.l0a.left.push({
                id: 'l0a_a',
                name: 'View Project Tab'
            })
        }



        if (loca.l0a && loca.l0a.l0a_b) {
            data.l0a.right.push({
                id: 'l0a_b',
                name: 'Admin for Projects'
            })
        } else if (loca.l0a) {
            data.l0a.left.push({
                id: 'l0a_b',
                name: 'Admin for Projects'
            })
        }

        if(loca.l0b && loca.l0b.l0b_a) {
            data.l0b.right.push({
                id: 'l0b_a',
                name: 'View Webgl Template Tab'
            })
        } else if (loca.l0b) {
            data.l0b.left.push({
                id: 'l0b_a',
                name: 'View Webgl Template Tab'
            })
        }

        if(loca.l0b && loca.l0b.l0b_b) {
            data.l0b.right.push({
                id: 'l0b_b',
                name: 'View Project Directory'
            })
        } else if (loca.l0b) {
            data.l0b.left.push({
                id: 'l0b_b',
                name: 'View Project Directory'
            })
        }

        if (loca.l0c && loca.l0c.l0c_a) {
            data.l0c.right.push({
                id: 'l0c_a',
                name: 'View Client Tab'
            })
        } else if (loca.l0c) {
            data.l0c.left.push({
                id: 'l0c_a',
                name: 'View Client Tab'
            })
        }


        this.setState({ comData: data, isLoading: false, resData: loca })

    }

    rewriteData(data, loca, response, userData) {

        if (data.l0a) {
            for (let i = 0; i < data.l0a.left.length; i++) {
                const element = data.l0a.left[i];
                loca.l0a[element.id] = false;
            }
            for (let i = 0; i < data.l0a.right.length; i++) {
                const element = data.l0a.right[i];
                loca.l0a[element.id] = true;
            }
        }

        if(data.l0b) {
            for (let i = 0; i < data.l0b.left.length; i++) {
                const element = data.l0b.left[i];
                loca.l0b[element.id] = false;
            }
            for (let i = 0; i < data.l0b.right.length; i++) {
                const element = data.l0b.right[i];
                loca.l0b[element.id] = true;
            }
        }

        if(data.l0c) {
            for (let i = 0; i < data.l0c.left.length; i++) {
                const element = data.l0c.left[i];
                loca.l0c[element.id] = false;
            }
            for (let i = 0; i < data.l0c.right.length; i++) {
                const element = data.l0c.right[i];
                loca.l0c[element.id] = true;
            }
        }

        var dataTo = {
            id: response[0]?.id,
            uid: userData.id,
            access: loca,
            last_updated: new Date(),
        }

        if (response.length === 0) {
            this.setState({ isLoading: true })
            Service.post(`/api/access/create_access_permission/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: dataTo,
            })
                .then(res => {
                    // this.props.enqueueSnackbar('Change saved!', {
                    //     variant: 'success'
                    // });
                    SnackbarUtils.success('Change saved!')
                    this.fetchOps();
                })
                .catch(error => {
                    this.setState({ isLoading: false })
                    errorMessage(this.props, error)
                });
        } else {
            Service.patch(`/api/access/update_access_permission/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: dataTo,
            })
                .then(res => {
                    // this.props.enqueueSnackbar('Change saved!', {
                    //     variant: 'success'
                    // });
                    SnackbarUtils.success('Change saved!')
                })
                .catch(error => {
                    errorMessage(this.props, error)
                });
        }

    }

    render() {
        return (
            <div>
                {(this.state.isLoading) ? (
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box>
                ) : (
                    <div>
                        <Box p={3} bgcolor="#d5f6e9">
                            <Accordions value={this.state.comData} resData={this.state.resData} user={this.props.value} data={this.state.data} handleToUpdate={this.rewriteData} />
                        </Box>
                    </div>
                )}
            </div>
        )
    }
}


// export default withSnackbar(UserPermission);
export default UserPermission;